import { Button, Heading, Stack, useToast } from '@chakra-ui/react';
import 'leaflet/dist/leaflet.css';
import SelectorDireccionMapa from '../selector/SelectorDireccionMapa';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const DEFAULT_POSITION = [39.547242, 2.729266];

const FaseRecogida = ({ onNext, onBack, tipoServicio, posicionInicial }) => {
  const [posicionSeleccionada, setPosicionSeleccionada] = useState(null);
  const [direccionOrigen, setDireccionOrigen] = useState('');
  const [ubicacionActual, setUbicacionActual] = useState(null);
  const { t } = useTranslation();
  const toast = useToast();

  // Obtener ubicación actual del usuario al cargar el componente
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const ubicacion = [position.coords.latitude, position.coords.longitude];
          setUbicacionActual(ubicacion);
          // Inicializar el mapa con la ubicación actual
          setPosicionSeleccionada((prev) => prev || ubicacion);
          console.log('[FaseRecogida] Ubicación actual obtenida:', ubicacion);
        },
        (error) => {
          console.warn('[FaseRecogida] Error al obtener ubicación:', error);
          // Si falla, usar posición por defecto
          setPosicionSeleccionada(DEFAULT_POSITION);
        }
      );
    } else {
      // Si no hay geolocalización, usar posición por defecto
      setPosicionSeleccionada(DEFAULT_POSITION);
    }
  }, []);

  // Manejar click en "Usar ubicación actual"
  const handleUsarUbicacionActual = () => {
    if (ubicacionActual) {
      setPosicionSeleccionada(ubicacionActual);
      toast({
        title: t('ubicacion_actual_usada') || 'Ubicación actual establecida',
        status: 'success',
        duration: 1500,
        isClosable: true,
      });
      
      // Esperar un momento para que se actualice la dirección y luego avanzar
      setTimeout(() => {
        handleNext();
      }, 500);
    } else {
      toast({
        title: t('ubicacion_no_disponible') || 'No se pudo obtener la ubicación actual',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Cuando el usuario pulsa "Siguiente":
  const handleNext = () => {
    console.log('[FaseRecogida] direccionOrigen capturada:', direccionOrigen);
    if (posicionSeleccionada) {
      onNext({ 
        puntoRecogida: posicionSeleccionada,
        origen_direccion: direccionOrigen 
      });
    }
  };

  return (
    <Stack spacing={6} align="center">
      <Heading size="md">{t('recogida_titulo')}</Heading>
      {/* Botones arriba del mapa */}
      <Stack direction="row" spacing={4}>
        <Button onClick={onBack}>{t('boton_atras')}</Button>
        <Button 
          colorScheme="blue" 
          onClick={handleUsarUbicacionActual}
          isDisabled={!ubicacionActual}
        >
          {t('usar_ubicacion_actual') || 'Usar ubicación actual'}
        </Button>
        <Button colorScheme="teal" onClick={handleNext} isDisabled={!posicionSeleccionada}>
          {t('boton_siguiente')}
        </Button>
      </Stack>
      <SelectorDireccionMapa
        alertaMensaje={t('recogida_alerta')}
        area_de_validez={[
          '/data/geojson/limites/Poly_Palma.geojson',
          '/data/geojson/limites/Poly_Marratxi.geojson'
        ]}
        posicionInicial={posicionSeleccionada || DEFAULT_POSITION}
        posicion={posicionSeleccionada}
        setPosicion={setPosicionSeleccionada}
        markerIconUrl={''}
        setDireccion={setDireccionOrigen}
      />
    </Stack>
  );
};

export default FaseRecogida;